<template>
  <div class="goods-list-wrapper" v-loading="loading">
    <div class="header-wrapper">
      <h3 class="title">{{shopInfo.name}} / 商品管理</h3>
      <div class="btn-group">
        <router-link :to="'/shop/' + shopInfo.id + '/tags'">
          <el-button type="primary" size="small">管理商品分类</el-button>
        </router-link>
        <router-link :to="'/shop/' + shopInfo.id +'/goods/add'">
          <el-button type="primary" icon="plus" size="small">添加商品</el-button>
        </router-link>
      </div>
    </div>
    <div class="manager-wrapper">
      <el-button @click="changeGoodsStatus">查看{{goodsStatus === 1 ? '已下架' : '在售' }}产品</el-button>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="goodsList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        stripe
        border
        style="width: 100%">
        <el-table-column
          align="center"
          type="selection">
        </el-table-column>
        <el-table-column
          align="center"
          prop="imgs"
          label="产品图片"
          width="180">
          <template slot-scope="scope">
            <div class="goods-pic-col">
              <img :src="scope.row.imgs[0] | ossurl"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="name"
          label="商品名字"
          width="180">
        </el-table-column>
        <el-table-column
          align="center"
          prop="total_sales"
          label="已售">
        </el-table-column>
        <el-table-column
          align="center"
          prop="stock"
          label="剩余库存">
        </el-table-column>
        <el-table-column
          align="center"
          prop="status"
          sortable
          :formatter="getStatus"
          label="状态">
        </el-table-column>
        <el-table-column
          align="center"
          prop="type"
          sortable
          :formatter="getSpecType"
          label="多规格类型">
        </el-table-column>
        <el-table-column
          align="center"
          width="200">
          <template slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
          </template>
          <template slot-scope="scope">
            <el-button size="small"><router-link :to="`/shop/${shopInfo.id}/goods/edit?goodsid=${scope.row.id}`">编辑</router-link></el-button>
            <el-button size="small" type="warning" @click="updateGoodsStatus(scope.row.id, scope.$index)">
              {{ goodsStatus === 1 ? '下架' : '上架'}}
            </el-button>
            <el-button size="small" type="danger" @click="deleteGoods(scope.row.id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-block">
      <el-pagination
        @current-change="currentPageChanged"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shop-goods-list',
  data () {
    return {
      loading: true,
      goodsList: [],
      search: '',
      currentPage: 1,
      totalPage: null,
      totalCount: 0,
      goodsStatus: 1,
      pageSize: 500
    }
  },
  computed: {
    shopInfo () {
      return this.$store.getters['shop/shopInfo']
    }
  },
  watch: {
    'goodsStatus' () {
      this.currentPageChanged()
    },
    '$route' (to, from) {
      this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
      this.currentPageChanged()
    }
  },
  mounted () {
    this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
    this.currentPageChanged()
  },
  methods: {
    getStatus (row, col, val) {
      return val === 1 ? '在售' : '下架'
    },
    getSpecType (row, col, val) {
      switch (val) {
        case 1:
          return '单规格'
        case 2:
          return '多规格'
        case 3:
          return '复杂规格'
      }
    },
    deleteGoods (productId, index) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        this.$store.dispatch('shop/deleteGoods', productId).then((res) => {
          if (!res.errcode) {
            this.$message('已删除产品: ' + this.goodsList[index].name)
            this.goodsList.splice(index, 1)
          }
        })
      })
    },
    updateGoodsStatus (productId, index) {
      let text = this.goodsStatus === 1 ? '商品下架后将不可见, 是否继续?' : '是否立刻上架该商品?'
      let success = this.goodsStatus === 1 ? '已下架商品: ' : '已上架商品：'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        let params = this.goodsList[index]
        params.product_id = productId
        params.status = 3 - this.goodsStatus
        this.$store.dispatch('shop/updateGoods', params).then((res) => {
          if (!res.errcode) {
            this.$message(success + this.goodsList[index].name)
            this.goodsList.splice(index, 1)
          }
        })
      })
    },
    changeGoodsStatus () {
      this.goodsStatus = 3 - this.goodsStatus
    },
    currentPageChanged () {
      this.loading = true
      this.$store.dispatch('shop/fetchGoodsList', {
        goodsStatus: this.goodsStatus,
        page: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        this.currentPage = res.current_page
        this.totalPage = res.total_page
        this.totalCount = res.total_count
        this.goodsList = res.products
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass">
.goods-list-wrapper
  padding: 20px;
  .header-wrapper
    overflow: hidden;
    margin-bottom: 10px;
  .title
    font-size: 14px;
    line-height: 2;
    font-weight: 600;
    float: left;
  .btn-group
    float: right;

  .goods-pic-col
    max-height: 100px;
    max-width: 100px;
    padding: 5px;

    img
      width: 100%;
      height: auto;

  .page-block
    padding-top: 20px;
    text-align: center;

  .manager-wrapper
    padding: 10px;
</style>



// WEBPACK FOOTER //
// goods-list.vue?ba39ae1a